// src/components/practice/tasks/writing/layouts/OsdB2FlyerLayout.jsx
import React from 'react';
import { parseOsdB2FlyerContent } from '../parsers/osdB2FlyerParser.js';

const OsdB2FlyerLayout = ({ inputContent, scenario }) => {
    const parsed = parseOsdB2FlyerContent(inputContent);

    if (!parsed) return null;

    return (
        <div className="my-8">
            {/* Situation text */}
            <div className="mb-4">
                <p className="text-gray-800 leading-relaxed">
                    <strong>Situation:</strong> {scenario.split('\n\n')[0]}
                </p>
            </div>

            {/* Flyer with notes */}
            <div className="border-2 border-gray-300 rounded-2xl bg-white shadow-lg p-8">
                {/* Title in Red */}
                {parsed.title && (
                    <div className="text-center mb-2">
                        <h2 className="text-2xl font-bold text-red-600 leading-tight">
                            {parsed.title}
                        </h2>
                    </div>
                )}

                {/* Subtitle */}
                {parsed.subtitle && (
                    <div className="text-center mb-6 relative">
                        <p className="text-lg font-semibold text-red-600 mb-2"
                           dangerouslySetInnerHTML={{ __html: parsed.subtitle }} />

                        {/* Note for subtitle with arrow pointing up */}
                        {parsed.subtitleNote && (
                            <div className="relative inline-block mt-2">
                                {/* Arrow pointing up - positioned above the note */}
                                <div className="absolute -top-6 left-1/2 transform -translate-x-1/2">
                                    <svg width="2" height="24" viewBox="0 0 2 24">
                                        <line x1="1" y1="24" x2="1" y2="0" stroke="#3B82F6" strokeWidth="2"/>
                                        <polygon points="1,0 5,6 -3,6" fill="#3B82F6"/>
                                    </svg>
                                </div>
                                <div className="bg-blue-100 border-2 border-blue-400 rounded-lg px-4 py-2 text-sm">
                                    <span className="italic">{parsed.subtitleNote}</span>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {/* Sections */}
                {parsed.sections.map((section, idx) => (
                    <div key={idx} className="mb-6">
                        {/* Only show section header if it's meaningful and not empty */}
                        {section.header && (
                            <p className="font-semibold text-lg mb-3 text-gray-800">
                                {section.header}:
                            </p>
                        )}

                        {/* List items with notes */}
                        <div className="space-y-3">
                            {section.items.map((item, i) => (
                                <div key={i} className="flex items-start justify-between gap-4">
                                    <div className="flex items-start flex-1">
                                        <span className="mr-2 mt-0.5">•</span>
                                        <span className="text-gray-800">
                                            {item.header && (
                                                <strong>{item.header}</strong>
                                            )}
                                            {item.header && item.text && ' '}
                                            {item.text}
                                        </span>
                                    </div>

                                    {/* Note box with arrow if exists */}
                                    {item.note && (
                                        <div className="flex items-center flex-shrink-0">
                                            {/* Arrow pointing left */}
                                            <svg width="20" height="2" viewBox="0 0 20 2" className="mr-2">
                                                <line x1="0" y1="1" x2="20" y2="1" stroke="#3B82F6" strokeWidth="2"/>
                                                <polygon points="0,1 6,5 6,-3" fill="#3B82F6"/>
                                            </svg>

                                            <div className="bg-blue-100 border-2 border-blue-400 rounded-lg px-3 py-2 text-sm">
                                                <span className="italic whitespace-nowrap">{item.note}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                ))}

                {/* Footer Section */}
                {parsed.footer && parsed.footer.length > 0 && (
                    <div className="text-center mt-8 pt-4 border-t-2 border-gray-200">
                        {parsed.footer.map((line, idx) => (
                            <p key={idx} className="text-gray-700 text-sm mb-1">
                                {line}
                            </p>
                        ))}
                    </div>
                )}
            </div>

            {/* Instruction below flyer */}
            <div className="mt-6 p-4 bg-gray-50 rounded-md">
                <p className="text-gray-800 leading-relaxed">
                    Schreiben Sie nun ein <strong>Beschwerde-E-Mail</strong> an die Jobbörse, in dem Sie auf <strong>alle Ihre Notizen</strong> eingehen.
                    Schreiben Sie circa <strong>120 Wörter</strong> und beschreiben Sie auch die formalen Kriterien (Anrede, Grußformel).
                </p>
            </div>
        </div>
    );
};

export default OsdB2FlyerLayout;